import React, { useContext, useRef, useEffect, ReactElement } from "react";
import { DashboardDataContext, NewDashboardType } from "../new-dashboard-context";
import { AcceptatieAjax } from "../hypotheek-acceptatie/acceptatie/acceptatie-ajax";
import classNames from "classnames";
import "./new-dashboard-container.scss";
import { Button } from "react-bootstrap";
import { Icon } from "adviesbox-shared";
import { SnelInzichtDrawer } from "../snel-inzicht-drawer/snel-inzicht-drawer";
import { TotalenWrapper } from "../hypotheek-totalen/totalen-wrapper";
import { ScenarioDrawer } from "../scenarios/scenario-drawer";
import { AppDataContext } from "../../../navigation/appdata-context";

export const NewDashboardContainerComponent = (): ReactElement => {
  const { open, setOpen, type, setType } = useContext(DashboardDataContext);
  const containerRef = useRef<HTMLDivElement>(null);
  const { berekenId } = useContext(AppDataContext);

  // Indien een (nieuw) berekenId wordt ingesteld, dan wordt de type gereset naar Geen
  // wat ervoor zorgt dat de openstaande drawers ge-unmount worden
  useEffect(() => {
    if (berekenId !== null) {
      setType(NewDashboardType.Geen);
    }
  }, [berekenId, setType]);


  useEffect(() => {
    if (!containerRef.current) return;

    if (open) {
      containerRef?.current.removeAttribute("inert");
      return;
    }

    containerRef?.current.setAttribute("inert", "");
  }, [open]);

  return (
    <div
      ref={containerRef}
      data-testid="dashboard-container"
      className={classNames("dashboard-container__content", {
        "dashboard-container__content--open": open,
        "dashboard-container__content--closed": !open
      })}
    >
      <div className="dashboard-container__totalen">
        {type !== NewDashboardType.Geen && open && <TotalenWrapper />}
        <div className="dashboard-container__actions">
          <Button data-testid="dashboard-container-close" onClick={() => setOpen(false)}>
            <Icon name="close" alt="Sluiten" iconSize={"m"} />
          </Button>
        </div>
      </div>
      {/* <div className="dashboard-container__header">{ type }</div> */}
      {type === NewDashboardType.SnelInzicht && <SnelInzichtDrawer />}
      {type === NewDashboardType.HypotheekAcceptatie && <AcceptatieAjax />}

      {type === NewDashboardType.Overlijden && <ScenarioDrawer soort={type} />}
      {type === NewDashboardType.Arbeidsongeschiktheid && <ScenarioDrawer soort={type} />}
      {type === NewDashboardType.Werkloosheid && <ScenarioDrawer soort={type} />}
      {type === NewDashboardType.Pensioen && <ScenarioDrawer soort={type} />}
    </div>
  );
};
